import {
  Component,
  Inject,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LessonCard } from '../../../interfaces/lesson-card.interface';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { AuthService } from '../../../services/auth.service';
import { ApiV2Service } from '../../../services/api-v2.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ActivityCard } from '../../../interfaces/activity-card.interface';
import { ActivityInfo } from '../../../interfaces/activity-info.interface';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { Activity } from '../../../models/activity.model';
import { HttpHeaders } from '@angular/common/http';
import { MessagesModalService } from 'src/app/services/messages-modal.service';
import { inherits } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-dialog-activity-grade',
  templateUrl: './dialog-activity-grade.component.html',
  styleUrls: ['./dialog-activity-grade.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogActivityGradeComponent implements OnInit {
  activityGradeForm: FormGroup;
  lessonsForm: FormControl;
  activityInfo: ActivityInfo = { id: null };
  activityId: number;
  activityName:string;
  activity: Activity;
  actualActivity: any;
  messageActivityId: any;
  lessonsIDs: any[] = [];

  lessons: LessonCard[] = [];
  allLessons: LessonCard[] = [];
  filteredLessons: Observable<LessonCard[]>;
  ownCards: LessonCard[];
  backupLesson: LessonCard[] = [];
  rechargingLesson:boolean=false

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' },
  };

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('lessonInput') lessonInput: ElementRef<HTMLInputElement>;
  @ViewChild('select') private select: MatSelect;
  constructor(
    private api: ApiV2Service,
    private spinner: SpinnerService,
    //private router: Router,
    //private route: ActivatedRoute,
    private translate: TranslateService,
    private ref: ChangeDetectorRef,
    private auth: AuthService,
    private message: MessagesModalService,
    private dialogRef: MatDialogRef<DialogActivityGradeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.activityGradeForm = new FormGroup({
      lessonsF: new FormControl(null),
    });
    this.lessonsForm = new FormControl(null);
  }

  ngOnInit(): void {
    // console.log(this.data.messageActivityId);
    this.getLessons({
      organizations: this.auth.currentMainOrganization.id,
      limit: 1000000,
    });

    this.activityGradeForm.get('lessonsF').valueChanges.subscribe(() => {
      this.select.close();
    });
  }
  getActualActivityCard() {
    this.api
      .getAlternativeService('GET_ACTIVITY_BY_ID', this.data.messageActivityId)
      .pipe(
        map((data) => {
          this.actualActivity = JSON.parse(JSON.stringify(data));
          (data['lessons'] = data['grades']
            ? this.allLessons.filter((item) => data['grades'].includes(item.id))
            : []),
            (data['color'] = '#EF7D00');
          data['isPublic'] = data['is_public'];
          data['isInstalled'] = data['is_installed'];
          data['question'] = data['text'] || data['clear_text'];
          data['categories'] = data['tags'] ? data['tags'] : [];
          data['text']=data['text']
          delete data['is_public'];
          delete data['is_installed'];
          delete data['clear_text'];
          delete data['text'];
          delete data['tags'];
          delete data['owner'];
          delete data['grades'];

          return data;
        })
      )
      .subscribe(
        (activity: ActivityCard) => {
          //console.log(activity)
          this.activityName=activity.question
          // console.log(this.activityName)
          this.lessons = activity.lessons;
          this.spinner.showSpinner = false;
          
          if(!this.rechargingLesson){
            this.activityGradeForm.get('lessonsF').setValue(null);
            this.activityGradeForm.get('lessonsF').setValue(this.lessons);
            this.lessonsForm.setValue(this.lessons);
          }
          else{
            this.activityGradeForm.get('lessonsF').setValue(null);
            this.lessonsForm.setValue(this.backupLesson);
            this.activityGradeForm.get('lessonsF').setValue(this.backupLesson);
            //console.log(this.activityGradeForm.get('lessonsF').value)
            this.rechargingLesson=false
          }
          // console.log(this.activityGradeForm);
          // console.log(this.activityGradeForm.value);
          // console.log(this.activityGradeForm.get('lessonsF'));
          // console.log(this.lessonsForm.value);
        },
        (error) => {
          console.log('Error: ', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  getLessons(params?: any) {
    //own lessons
    let filteredLessons2=[]
    console.log('get own lessons')
    this.spinner.showSpinner = true;
    this.api.getService('GET_OWN_LESSONS', params).pipe(map((data) => {
      for (const key in data['results']) {
        if (data['results'].hasOwnProperty(key)) {
          data['results'][key]['color'] = '#00AFB4';
          data['results'][key]['isPublic'] = data['results'][key]['is_public'];
          data['results'][key]['isInstalled'] = data['results'][key]['is_installed'];
          delete data['results'][key]['is_public'];
          delete data['results'][key]['is_installed'];
        }
      }
      return data['results'];
    })).subscribe(
      (lessons: LessonCard[] | any[]) => {
        this.ownCards = lessons;
        this.spinner.showSpinner = false;
        filteredLessons2=this.ownCards
        console.log("own lessons ",this.ownCards)
      },
      (error) => {
        console.log('Error:', error);
        this.spinner.showSpinner = false;
      }
    );

    console.log('get lesson')
    this.spinner.showSpinner = true;
    if (this.auth.currentMainOrganization.organizationType === 'Escuela') {
      this.api
        .getService('TEACHER_LESSONS', params)
        .pipe(
          map((data) => {
            for (const key in data['results']) {
              if (data['results'].hasOwnProperty(key)) {
                data['results'][key]['color'] = '#00AFB4';
                data['results'][key]['isPublic'] =
                  data['results'][key]['is_public'];
                data['results'][key]['isInstalled'] =
                  data['results'][key]['is_installed'];
                delete data['results'][key]['is_public'];
                delete data['results'][key]['is_installed'];
              }
            }
            return data['results'];
          })
        )
        .subscribe(
          (lessons: LessonCard[] | any[]) => {
            this.allLessons = lessons.filter((item: LessonCard) => {
              return (
                !item.isInstalled &&
                !item.owner.organizations.some(
                  (item: any) => item.organization_type === 'Familia'
                )
              );
            });
            filteredLessons2=filteredLessons2.concat(this.allLessons)
            
            console.log(this.allLessons);

            //Eliminamos los duplicados
            let temp=[]
            filteredLessons2=filteredLessons2.filter((item)=>{
              //console.log(temp)
              if(!temp.some(item2=>item.id==item2.id))
                {temp.push(item)
                return item}
              else
                console.log(item.id, 'existe')

            });
            console.log(filteredLessons2);
            this.allLessons=filteredLessons2
            this.filteredLessons = this.activityGradeForm
              .get('lessonsF')
              .valueChanges.pipe(
                startWith(''),
                map((value) => this._filter(value, this.allLessons))
              );
            // console.log(
            //   this.allLessons,
            //   this.filteredLessons
            // );
            if(!this.rechargingLesson)
            {console.log('get lesson recharging false',this.backupLesson)
              this.getActualActivityCard();
              }
              else{
                console.log('get lesson recharging',this.backupLesson)
                this.activityGradeForm.get('lessonsF').setValue(null);
            this.lessonsForm.setValue(this.backupLesson);
            this.activityGradeForm.get('lessonsF').patchValue(this.backupLesson);
            // console.log(this.activityGradeForm.get('lessonsF').value)
            this.rechargingLesson=false
              }
            this.spinner.showSpinner = false;
          },
          (error) => {
            console.log('Error:', error);
            this.spinner.showSpinner = false;
          }
        );
    } else {
      this.api
        .getService('GET_OWN_LESSONS', params)
        .pipe(
          map((data) => {
            for (const key in data['results']) {
              if (data['results'].hasOwnProperty(key)) {
                data['results'][key]['color'] = '#00AFB4';
                data['results'][key]['isPublic'] =
                  data['results'][key]['is_public'];
                data['results'][key]['isInstalled'] =
                  data['results'][key]['is_installed'];
                delete data['results'][key]['is_public'];
                delete data['results'][key]['is_installed'];
              }
            }
            return data['results'];
          })
        )
        .subscribe(
          (lessons: LessonCard[] | any[]) => {
            if (
              this.auth.currentMainOrganization.organizationType === 'Familia'
            ) {
              this.allLessons = lessons.filter((item: LessonCard) => {
                return (
                  !item.isInstalled &&
                  item.owner.organizations.some(
                    (item: any) => item.organization_type === 'Familia'
                  )
                );
              });
            }
            this.filteredLessons = this.activityGradeForm
              .get('lessonsF')
              .valueChanges.pipe(
                startWith(''),
                map((value) => this._filter(value, this.allLessons))
              );
            // console.log(this.allLessons, this.activityGradeForm.value);
            this.getActualActivityCard();
            this.spinner.showSpinner = false;
          },
          (error) => {
            console.log('Error:', error);
            this.spinner.showSpinner = false;
          }
        );
    }
  }

  private _filter(value: any, options: any[]): any[] {
    const filterValue = value && value.name ? value.name.toLowerCase() : value;
    //console.log(filterValue)
    return options.filter((option) =>
      option.name.toLowerCase().includes(filterValue) ? option.name : ''
    );
  }

  addLesson(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (event.input) {
      event.input.value = '';
    }
    this.activityGradeForm.get('lessonsF').setValue('');
  }

  removeLesson(lesson: LessonCard): void {
    const index = this.lessons.indexOf(lesson);

    if (index == -1) {
      console.log(lesson);
      const lesssons = this.activityGradeForm.get('lessonsF').value;
      this.removeFirst(lesssons, lesson);
      this.activityGradeForm.get('lessonsF').setValue(lesssons); // To trigger change detection
    } else {
      this.removeFromGrade(lesson.id);
      const lesssons = this.activityGradeForm.get('lessonsF').value;
      this.removeFirst(lesssons, lesson);
      this.activityGradeForm.get('lessonsF').setValue(lesssons); // To trigger change detection
      // if (index >= 0) {
      //   console.log('REMOVE', lesson, index);
      //   this.lessons.splice(index, 1);
      //   this.lessonsIDs.splice(index, 1);
      //   console.log('remove', this.lessonsIDs);
      // }
    }
  }
  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }
  lessons2Id() {
    //
    if (
      this.activityGradeForm.get('lessonsF').value != null ||
      this.activityGradeForm.get('lessonsF').value != undefined
    ) {
      this.filteredLessons = this.activityGradeForm
        .get('lessonsF')
        .valueChanges.pipe(
          startWith(''),
          map((value) => this._filter(value, this.allLessons))
        );

      //console.log('Id Form activitygradeform',this.activityGradeForm.get('lessonsF').value.map((item: LessonCard) => item.id))
      this.lessonsIDs = this.activityGradeForm
        .get('lessonsF')
        .value.map((item: LessonCard) => item.id);
      // console.log(this.lessonsIDs);
      // console.log(this.lessonsIDs.length);
      return this.lessonsIDs;
    }
    // if(this.lessonsForm.value!=null||this.lessonsForm.value!=undefined){
    //   console.log(this.lessonsIDs=this.lessonsForm.value.map((item: LessonCard) => item.id))
    //   this.lessonsIDs=this.lessonsForm.value.map((item: LessonCard) => item.id)
    //   return this.lessonsIDs
    // }
  }
  lessonSelected(event: MatAutocompleteSelectedEvent): void {
    console.log('SELECTED', event, event.option.value);
    this.lessons.push(event.option.value);
    this.lessonInput.nativeElement.value = '';
    this.lessonsIDs = this.activityGradeForm
      .get('lessonsF')
      .value.map((item: LessonCard) => item.id);
    this.activityGradeForm.get('lessonsF').setValue('');
  }

  public closeMe() {
    this.dialogRef.close();
  }

  removeFromGrade(lessonID: any) {
    // console.log(lessonID);
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: { grades: [lessonID] },
    };
    // console.log(options);

    this.api
      .deleteAlternativeServiceBody(
        'ACTIVITIES_TO_GRADE',
        options,
        this.data.messageActivityId
      )
      .subscribe(
        (result: any) => {
          // console.log(result);
        },
        (error) => {
          this.tryagain();
          console.log('Error: ', error);
          this.spinner.showSpinner = false;
        }
      );
  }

  tryagain() {
    const body = {
      grades: this.activityGradeForm
        .get('lessonsF')
        .value.map((item: LessonCard) => item.id),
    };
    // console.log(body);
    this.api
      .patchAlternativeService(
        'SHOW_HIDE_ACTIVITY',
        body,
        this.data.messageActivityId
      )
      .subscribe(
        (result: any) => {
          // console.log(result);
          console.log('funcionó??');
        },
        (error) => {
          console.log('Error: ', error);
          this.spinner.showSpinner = false;
        }
      );
  }
  createNewLesson() {
    //this.dialogRef.close(this.lessonsIDs)
    
    this.backupLesson = this.activityGradeForm.get('lessonsF').value;
    //this.closeMe()
    this.message
      .openGradeCreatorDialog('info', '', this.data.messageActivityId)
      .afterClosed()
      .subscribe((result: LessonCard) => {
       if(result!=undefined ||result!= null){
        console.log('llego aqui al crear asignatura', result);
        this.rechargingLesson=true
        this.backupLesson.push(result);
       this.allLessons.push(result)
        this.filteredLessons = this.activityGradeForm
          .get('lessonsF')
          .valueChanges.pipe(
            startWith(''),
            map((value) => this._filter(value, this.allLessons))
          );
        console.log(this.allLessons)
      
        this.activityGradeForm.get('lessonsF').patchValue(this.backupLesson)
        console.log(this.activityGradeForm.get('lessonsF').value)
        console.log(this.activityGradeForm.get('lessonsF').value[0]['name'])
          }
          else{
            console.log("entramos acá")
          }
      });
      
  }

  public closeMe2() {
    this.dialogRef.close();
    // this.dialogRef.close(this.lessonsIDs);
  }
}
